import { call, put, takeLatest } from 'redux-saga/effects';
import KnowledgeAction, { KnowledgeTypes } from 'redux/actions/knowledgeAction';
import { getIncidentTicket, getRequestTicket } from 'services/ticketServices';
import { searchAllKnowledge } from 'services/knowledgeServices';
import BaseAction from '../actions/baseAction';


export function* getKnowledge(action: any): any {
  try {
    const result = yield call(searchAllKnowledge, action.params);
    if (result.status === 200) {
      yield put(KnowledgeAction.getKnowledgeSuccess(result.data));
    }
  } catch (error) {
    yield put(KnowledgeAction.getKnowledgeFail());
    yield put(BaseAction.errorHandling({
      message: `GET_KNOWLEDGE ${error}`
    }));
  }
}

export function* getMoreKnowledge(action: any): any {
  try {
    const result = yield call(searchAllKnowledge, action.params);
    if (result.status === 200) {
      yield put(KnowledgeAction.getMoreKnowledgeSuccess(result.data));
    }
  } catch (error) {
    yield put(BaseAction.errorHandling({
      message: `GET_MORE_KNOWLEDGE ${error}`
    }));
  }
}

export function* getIncidentTicketList(action: any): any {
  try {
    const result = yield call(getIncidentTicket, action.params);
    if (result.status === 200) {
      yield put(KnowledgeAction.getIncidentTicketListSuccess(result.data));
    }
  } catch (error) {
    yield put(BaseAction.errorHandling({
      message: `GET_INCIDENT_TICKET_LIST ${error}`
    }));
  }
}

export function* getRequestTicketList(action: any): any {
  try {
    const result = yield call(getRequestTicket, action.params);
    if (result.status === 200) {
      yield put(KnowledgeAction.getRequestTicketListSuccess(result.data));
    }
  } catch (error) {
    yield put(BaseAction.errorHandling({
      message: `GET_INCIDENT_TICKET_LIST ${error}`
    }));
  }
}

export const watchKnowledge = [
  takeLatest(KnowledgeTypes.GET_KNOWLEDGE, getKnowledge),
  takeLatest(KnowledgeTypes.GET_MORE_KNOWLEDGE, getMoreKnowledge),
  takeLatest(KnowledgeTypes.GET_INCIDENT_TICKET_LIST, getIncidentTicketList),
  takeLatest(KnowledgeTypes.GET_REQUEST_TICKET_LIST, getRequestTicketList),
]
